// extracted by mini-css-extract-plugin
module.exports = {"scoreExplain":"ScoreExplain_scoreExplain__Dd3iR","scoreExplainText":"ScoreExplain_scoreExplainText__06yhV","info":"ScoreExplain_info__DWUcK"};